export const AUTH_TOKEN = 'auth_token';
export const AUTH_ROLE = 'role';
export const AUTH_ID = 'AUTH_ID';
export const AUTH_NAME = 'name';